export const actions = {
  async getListTicket ({ rootState }, params) {
    return await this.$axios.get(`${process.env.BASE_API_V4}doctor/ticket?${params}`, {
      headers: {
        DeviceType: 'web',
        Authorization: 'Bearer ' + rootState.user.auth.token
      }
    })
  },
  async getListChat ({ rootState }, ticketID) {
    return await this.$axios.get(`${process.env.BASE_API_V4}doctor/ticket/${ticketID}/chat`, {
      headers: {
        DeviceType: 'web',
        Authorization: 'Bearer ' + rootState.user.auth.token
      }
    })
  },
  async sendMessage ({ rootState }, payload) {
    const { ticketID, form } = payload
    const formData = new FormData()
    if (form.Answer) {
      formData.append('Answer', form.Answer)
    }
    if (form.File) {
      formData.append('File', form.File)
    }
    return await this.$axios.post(`${process.env.BASE_API_V4}doctor/ticket/chat/${ticketID}`, formData, {
      headers: {
        DeviceType: 'web',
        Authorization: 'Bearer ' + rootState.user.auth.token
      }
    })
  },
  async readChat ({ rootState }, ticketID) {
    return await this.$axios.post(`${process.env.BASE_API}doctor/ticket/read`, { ID: ticketID }, {
      headers: {
        DeviceType: 'web',
        Authorization: 'Bearer ' + rootState.user.auth.token
      }
    })
  },
  async getTicketGeneralProblem () {
    return await this.$axios.get(`${process.env.BASE_API_V4}public/ticket/general-problem`)
  },
  async createTicket ({ rootState }, payload) {
    const formData = new FormData()
    formData.append('PracticingID', payload.PracticingID)
    formData.append('ProblemID', payload.ProblemID)
    formData.append('DoctorID', payload.DoctorID)
    formData.append('Description', payload.Description)
    payload.Image.map((obj) => {
      formData.append('Image[]', obj)
    })
    return await this.$axios.post(`${process.env.BASE_API_V4}doctor/ticket/create`, formData, {
      headers: {
        DeviceType: 'web',
        Authorization: 'Bearer ' + rootState.user.auth.token
      }
    })
  }
}
